/**
 * GP Practice Selector Component
 * 
 * Handles the interaction between the GP practice dropdown and the 
 * "My GP is not listed" checkbox. When checkbox is checked, it disables
 * the dropdown and assigns the Walk In GP practice (ID 16).
 */
class GpPracticeSelector {
    constructor() {
        this.gpSelect = document.getElementById('gp_practice_select');
        this.notListedCheckbox = document.getElementById('gp_not_listed');
        this.walkInInput = document.getElementById('walk_in_gp_id');
        
        if (this.gpSelect && this.notListedCheckbox && this.walkInInput) {
            this.init();
        }
    }

    init() {
        this.bindEvents();
        this.setInitialState();
    }

    bindEvents() {
        this.notListedCheckbox.addEventListener('change', (e) => {
            this.handleCheckboxChange(e.target.checked);
        });
    }

    setInitialState() {
        // If checkbox is checked on page load (form validation errors), 
        // ensure proper state
        if (this.notListedCheckbox.checked) {
            this.handleCheckboxChange(true);
        }
    }

    handleCheckboxChange(isChecked) {
        if (isChecked) {
            // Disable the dropdown and clear its value
            this.gpSelect.disabled = true;
            this.gpSelect.value = '';
            
            // Set the walk-in GP ID as the gp_practice_id value
            this.gpSelect.name = '';
            this.walkInInput.name = 'gp_practice_id';
            
            // If using Select2, disable it properly
            if (window.$ && $(this.gpSelect).hasClass('select2')) {
                $(this.gpSelect).prop('disabled', true).trigger('change');
            }
        } else {
            // Re-enable the dropdown
            this.gpSelect.disabled = false;
            
            // Restore original field names
            this.gpSelect.name = 'gp_practice_id';
            this.walkInInput.name = 'walk_in_gp_id';
            
            // If using Select2, enable it properly
            if (window.$ && $(this.gpSelect).hasClass('select2')) {
                $(this.gpSelect).prop('disabled', false).trigger('change');
            }
        }
    }
}

// Auto-initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    new GpPracticeSelector();
});

export default GpPracticeSelector;